import {
  E164Number,
  PhoneNumber,
  CountryCode,
  parsePhoneNumber,
  AsYouType,
} from 'libphonenumber-js'

export interface ConvertedPhoneNumber {
  formatted: string | E164Number
  number?: PhoneNumber
}

export function onlyKeepPlusAtStart(phoneNumber: string) {
  return phoneNumber.replace(/(?!^)\+/, '')
}

export function isParseable(phoneNumber: string): boolean {
  const rawNumber = phoneNumber.trim().split(' ').join('')

  if (rawNumber.includes('+')) {
    return rawNumber.length > 4
  }

  return rawNumber.length > 0 && +rawNumber !== 0
}

/**
 * Some numbers that seem parseable can still fail,
 * e.g. a German number starting with "3" will throw an exception.
 */
export function tryParse(
  phoneNumber: string,
  defaultRegion: CountryCode,
): PhoneNumber | null {
  try {
    return parsePhoneNumber(phoneNumber, defaultRegion)
  } catch (error) {
    return null
  }
}

export function getPhoneNumberFromString(
  phoneNumber: string,
  defaultRegion: CountryCode,
): ConvertedPhoneNumber {
  const cleanNumber = onlyKeepPlusAtStart(phoneNumber)
  const asYouType = new AsYouType(defaultRegion)

  if (!isParseable(cleanNumber)) {
    return {
      formatted: cleanNumber,
    }
  }

  const asYouTypeFormat = asYouType.input(phoneNumber)

  return {
    number: asYouType.getNumber(),
    formatted: asYouTypeFormat,
  }
}

export const getError = (
  number: PhoneNumber,
  formatted: string | E164Number,
) => {
  if (formatted.length === 0) {
    return undefined
  }

  if (!number || !number.isValid()) {
    return 'Die Telefonnummer ist ungültig.'
  }

  return undefined
}
